//@ts-ignore
export const isVulcan = () => window._platform === 'vulcan';
